export default function EditJaringan() {
  return (
    <div>EditJaringan</div>
  )
}
